<template>
    <div :class="classNameToUse" v-if="groupList.length > 0">
        <app-card-for-group v-for="group in groupList" :key="group.id" :group="group"></app-card-for-group>
    </div>
    <div v-else class="container has-text-centered">This board has no groups or objects.</div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import CardForGroup from '../components/main/CardForGroup';

  export default {
    name: "screen-board",
    components: {
      appCardForGroup: CardForGroup
    },
    data() {
      return {
      };
    },
    computed: {
      ...mapGetters('auth', ['isAuth']),
      ...mapGetters('ui', ['screenType']),
      ...mapGetters('objects', ['boardById', 'groupsByBoardId']),
      board() {
        return this.boardById(this.$route.params.id);
      },
      groupList() {
        return this.groupsByBoardId(this.$route.params.id).filter(item => {
          return item.items.length > 0;
        });
      },
      classNameToUse() {
        return `cards ${this.screenType}`;
      }
    }
  }
</script>

<style scoped>
    .cards {
        display: flex;
        flex-wrap: wrap;
    }

    .cards > * {
        min-width: 270px;
        flex-shrink: 0;
        flex-grow: 1;
        margin-right: 0.5rem;
        margin-bottom: 0.75rem;
    }

    @media all and (min-width: 768px) {
        .cards > * {
            flex-shrink: 0.5;
        }
    }

    @media all and (min-width: 1024px) {
        .cards > * {
            flex-shrink: 0.3;
        }
    }
</style>